import React from 'react'
import styled from 'styled-components'
import { getMsalLogout, getMsalUserInfo } from '../../authConfig';
import "../../styles/Modal.css";
import { ReactComponent as LockSVG } from '../../icons-svg/icons/lock_svg.svg';

const StyledInvalidAccess = styled.div`
	width: 100%; height: 100%; background-color: black;
	display: flex; flex-direction: column;
	justify-content: center; align-items: center;
	color: white;
	font-size: 16px;
	text-align: center;
	li {text-align: left;}
	a{
		color: black;
		text-decoration: underline !important;
		cursor: pointer;
	}
	button{
		background: none;
		color: white;
		border: none;
		text-decoration: underline;
		padding-left: 0px;
	}
`

const getMessage = ({level, error}) => {
	const { name } = getMsalUserInfo();
	if (error) {
		return (
			<p>
				Something Went Wrong on our end. Please try again!
				<br />
			</p>
		)
	}

const navigateToSnow = () => {
  const newWindow = window.open("https://servicenow.otis.com/esc", "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};

	  
	switch(level) {
		case "tenant": return (
			<p>
				{`Hello, ${name}`}
				<br />
				Looks like you have logged in using unauthorized Active Directory tenant.
				<br />
				Please use a trusted Azure Active Directory tenant to log in.
				<br />
				<button className="link-button" onClick={(e) => {getMsalLogout()}}>
              Logout
            </button>
			</p>
		)
		case "user": return (
			<p>
				{`Hello, ${name}, Welcome to OTIS Upgrade Portal(OCUP)!`}
				<br />
				Looks like you do not have the access rights for OCUP.
				<br />
				<br />
				Please raise an access request on &nbsp;
				<button className="link-button" onClick={(e) => {navigateToSnow()}}>
				Servicenow
            </button>.
				<br /> 
				<br />
				<button className="link-button" onClick={(e) => {getMsalLogout()}}>
              Logout
            </button>
			</p>
		);
		case "role": return (
			<p>
				{`Hello, ${name}, Welcome to OTIS Upgrade Portal(OCUP)!`}
				<br />
				Looks like you do not have the access rights for this page.
				<br />
				<br />
				Please raise an access request on &nbsp;
				<button className="link-button" onClick={(e) => {navigateToSnow()}}>
				Servicenow
            </button>.
				<br /> 
				<br />
				<button className="link-button" onClick={(e) => {getMsalLogout()}}>
              Logout
            </button>
			</p>
		)
		default:
			return null;
	}
}

export const InvalidAccess = ({level, error}) => {
	return (
		<StyledInvalidAccess>
			{!error ? <LockSVG/> : null }
			<br />
			{getMessage({level, error})}
		</StyledInvalidAccess>
	)
}